import { footerGroups } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="mt-16 md:mt-28 bg-primary-900 text-background-100">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="mx-auto max-w-6xl grid grid-cols-1 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3">
              <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-background-50 text-primary-900">
                <i className="ri-file-search-line w-5 h-5 flex items-center justify-center" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">爆料黑料</span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-primary-100">
              深挖黑料背后真相，从黑料内幕到细节分析，整理完整时间线和证据链，
              把零散爆料收成可复核的专题合集。
            </p>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
                {group.title}
              </h4>
              <ul className="mt-4 flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-primary-100 transition-colors cursor-pointer hover:text-accent-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto max-w-6xl px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <span className="text-xs text-primary-200">
            © 2026 爆料黑料 · 内容整理与专题复盘
          </span>
          <span className="flex items-center gap-2 text-xs text-primary-200">
            <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center text-accent-400" />
            素材均标注来源，结论随证据更新
          </span>
        </div>
      </div>
    </footer>
  );
}